import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import {createAsyncThunk } from "@reduxjs/toolkit";
import { url } from "@constants/url-constants";

export const loginUser = createAsyncThunk(
    "session/login",
    async (user, { rejectWithValue }) => {
      try {
        const response = await Client(API_METHOD.POST, url.login, user);
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error
        );
      }
    }
  );
  export const logOut = createAsyncThunk("logout", async () => {
    const response = await Client(API_METHOD.DELETE, url.logout);
    return response.data;
  });
  